export const shape = `
<svg width="100" height="251" viewBox="0 0 100 251" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0 14.692L25.3752 0L100 43.3895V236.033L75.0341 251L0 207.61V14.692Z" fill="black"/>
</svg>
`
